// QL-150 — display of bank-synced savings plans (the spec's "recurring
// portfolios"). The bank is master for a plan's contents, so this surface
// never edits them: plans are created and changed only via the public API
// sync. The one interaction is the step-3 follow-up entry point — a Followup
// button on ACTIVE plans that opens a new advice session seeded from the
// agreement's lines.

// Local translations
export const T = {
  en_GB: {
    savingsPlans: "Savings plans",
    savingsPlansDescription: "Recurring savings agreements synced from the bank.",
    active: "active",
    pending: "awaiting bank",
    followup: "Followup",
    error: "Error",
    ok: "OK",
    units: "units",
    account: "Account",
    linkedGoal: "Linked Goal",
    startDate: "Start date",
    endDate: "End date",
    vendor: "Vendor",
    externalId: "External ID",
    notSet: "—",
    line: "line",
    lines: "lines",
  },
  nb_NO: {
    savingsPlans: "Spareavtaler",
    savingsPlansDescription: "Faste spareavtaler synkronisert fra banken.",
    active: "aktiv",
    pending: "venter på bank",
    followup: "Oppfølging",
    error: "Feil",
    ok: "OK",
    units: "andeler",
    account: "Konto",
    linkedGoal: "Tilknyttet mål",
    startDate: "Startdato",
    endDate: "Sluttdato",
    vendor: "Leverandør",
    externalId: "Ekstern ID",
    notSet: "—",
    line: "linje",
    lines: "linjer",
  },
} as const;
